import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { IrfeProjeto } from '../models/irfe-projeto.model';
import { Observable } from 'rxjs';
import { AditivoIrcpIrfe } from '../models/aditivo-ircp-irfe.model';

@Injectable({
  providedIn: 'root',
})
export class IrfeProjetoService extends BaseService<IrfeProjeto> {
  public readonly LABEL_TOOLTIP: string = 'Instrumento de repasse federal';

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/irfe';
  }

  public summary(idProjeto:number): Observable<any> {
    return this.http.get<any>(this.baseUrl+'/summary/'+idProjeto, { headers: this.headers });
  }

  public getAditivoList(id: number): Observable<AditivoIrcpIrfe[]> {
    return this.http.get<AditivoIrcpIrfe[]>(this.baseUrl + '/aditivo-list/' + id, { headers: this.headers });
  }
  
  public getAditivoById(aditivo_id: number): Observable<AditivoIrcpIrfe> {
    return this.http.get<AditivoIrcpIrfe>(this.baseUrl + '/aditivo/' + aditivo_id, { headers: this.headers });
  }
  
  public getAditivoInit(ircp_id: number): Observable<AditivoIrcpIrfe> {
    return this.http.get<AditivoIrcpIrfe>(this.baseUrl + '/aditivo-init/' + ircp_id, { headers: this.headers });
  }

  public getTiposAditivosList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/tipos-aditivos-list', { headers: this.headers });
  }

  public aditivoCreate(obj: AditivoIrcpIrfe): Observable<AditivoIrcpIrfe> {
    return this.http.post<AditivoIrcpIrfe>(this.baseUrl + '/aditivo', obj, { headers: this.headers });
  }

  public aditivoUpdate(obj: AditivoIrcpIrfe, id: number): Observable<AditivoIrcpIrfe> {
    return this.http.put<AditivoIrcpIrfe>(this.baseUrl + '/aditivo/' + id, obj, { headers: this.headers });
  }

  public aditivoDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/aditivo/' + id, { headers: this.headers });
  }

}
